var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('img',{staticClass:"mb-5 logo",attrs:{"src":require("@/assets/variedades-aby-logo.jpg"),"alt":"Vuetify.js"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }